import React from "react";
import { connect } from "react-redux";
import { FooterIconButton } from "../../../base/buttons";
import { translate } from "../../../base/i18n";
import { isCheckPermission } from "../../../base/localuser";
import { PERMISSION } from "../../../base/participants";

import { isPropertyOpen, videoLayoutMode } from "../../../video-layout-mode";
import { SET_SCREEN_TYPE_MODAL_ID } from "../../constants";

function SwitchScreenShareButton({ t, isLayoutPermission, isShared }) {
    if (!APP.layout.mode.screenShare) return null;

    const startScreenShare = () => {
        APP.UI.closeModal();
         // 내가 화면 공유가 아닌데 화면 공유 중인 경우
        if (!APP.mateManagement.getScreenSharing() && isShared) {
            // 화면 공유 취소 요청 
            APP.mateManagement.requestStopScreenShare();
            return;
        } 
        
        // 내가 화면 공유 중인 경우 
        // 화면 공유중이 아닌 경우
        if (!isShared) APP.UI.openModal(SET_SCREEN_TYPE_MODAL_ID);
        else APP.mateManagement.toggleScreenShare(false); 
    }

    return (
        <FooterIconButton mode="screen" name={t("conference.screenShare")} checked={isShared} onClick={startScreenShare} /> 
    )
}

function _mapStateToProps(state) {
    const isSharingVideo = state['features/screen-share'].sharingVideo.member_uuid ? true : false;
    const isLayoutPermission = isCheckPermission(state, PERMISSION.LAYOUT);

    return {
        isShared: isSharingVideo,
        isLayoutPermission
    }
}

export default translate(connect(_mapStateToProps)(SwitchScreenShareButton));